<template>
    <div>
        <CCol sm="12">
            <CCard>
                <CCardBody class="d-flex flex-column">
                    <div class="d-flex mb-2 justify-content-end align-items-start">
                        <!-- Title -->
                        <p class="flex-grow-1">{{ $t('hero') }}</p>
                        <!-- Language dropdown -->
                        <LanguageDropdown v-model="currentLanguage"></LanguageDropdown>
                    </div>
                    <!-- Form -->
                    <div class="row">
                        <!-- Image -->
                        <div class="col-12 col-lg-5">
                            <div role="group" class="form-group">
                                <label class=""> {{ $t('imageMandatory') }}</label>
                                <GalleryPicker class="gallery-picker" v-model="hero.image" :ratioWidth="1" :ratioHeight="1"
                                    v-bind:class="{ 'is-invalid': genericValidator(hero.image, attemptedSubmit) === false || errorValidator('Image') === false }"
                                    :max="1"></GalleryPicker>
                            </div>
                        </div>
                        <div class="col-12 col-lg-7">
                            <div class="row">
                                <!-- Titles -->
                                <div class="col-6">
                                    <div role="group" class="form-group">
                                        <label class="">{{ $t('titlesMandatory') }}</label>
                                        <CInput type="text" v-model="hero.titles[currentLanguage.key]"
                                            :invalid-feedback="errorOutput['Titles']"
                                            :is-valid="genericValidator(hero.titles, attemptedSubmit) && errorValidator('Titles')">
                                        </CInput>
                                    </div>
                                </div>
                                <!-- ButtonContents -->
                                <div class="col-6">
                                    <div role="group" class="form-group">
                                        <label class=""> {{ $t('buttonContentsMandatory') }}</label>
                                        <CInput type="text" v-model="hero.buttonContents[currentLanguage.key]"
                                            :invalid-feedback="errorOutput['ButtonContents']"
                                            :is-valid="genericValidator(hero.buttonContents, attemptedSubmit) && errorValidator('ButtonContents')">
                                        </CInput>
                                    </div>
                                </div>
                                <div class="col-6">
                                    <!-- ButtonUrl -->
                                    <div role="group" class="form-group">
                                        <label class=""> {{ $t('buttonUrlMandatory') }}</label>
                                        <CInput type="text" v-model="hero.buttonUrl"
                                            :invalid-feedback="errorOutput['ButtonUrl']"
                                            :is-valid="genericValidator(hero.buttonUrl, attemptedSubmit) && errorValidator('ButtonUrl')">
                                        </CInput>
                                    </div>
                                </div>
                                <!-- Contents -->
                                <div class="col-12">
                                    <div role="group" class="form-group">
                                        <label class=""> {{ $t('contentsMandatory') }}</label>
                                        <!-- {{ errorOutput['Contents'] }} -->
                                        {{ errorValidator('Contents') }}
                                        <vue-editor v-model="hero.contents[currentLanguage.key]"
                                            v-bind:class="{ 'is-invalid': genericValidator(hero.contents, attemptedSubmit) === false || errorValidator('Contents') }"></vue-editor>
                                        <div v-if="errorOutput['Contents']" class="invalid-feedback">
                                            {{ errorOutput['Contents'] }}</div>
                                    </div>
                                </div>
                                <!-- <div role="group" class="form-group">
                                    <label class="">{{ $t('contentsMandatory') }}</label>
                                    <CInput type="text" v-model="hero.contents[currentLanguage.key]"
                                        :invalid-feedback="errorOutput['Contents']"
                                        :is-valid="genericValidator(hero.contents, attemptedSubmit) && errorValidator('Contents')">
                                    </CInput>
                                </div> -->
                                <!-- <div class="col-6">
                                    <div role="group" class="form-group">
                                        <label class=""> {{ $t('isHomeMandatory') }}</label>
                                        <CInput type="text" v-model="hero.isHome" :invalid-feedback="errorOutput['IsHome']"
                                            :is-valid="genericValidator(hero.isHome, attemptedSubmit) && errorValidator('IsHome')">
                                        </CInput>
                                    </div>
                                </div> -->
                                <!-- <div class="col-6">
                                    <div role="group" class="form-group">
                                        <label class=""> {{ $t('isGalleryMandatory') }}</label>
                                        <CInput type="text" v-model="hero.isGallery"
                                            :invalid-feedback="errorOutput['IsGallery']"
                                            :is-valid="genericValidator(hero.isGallery, attemptedSubmit) && errorValidator('IsGallery')">
                                        </CInput>
                                    </div>
                                </div> -->
                            </div>
                        </div>
                        <div class="col-12">
                            <!-- Action button + submitting -->
                            <div class="text-right">
                                <CSpinner v-if="submitting" variant="success" small class="align-self-end"></CSpinner>
                                <CButton v-else type="button" class="btn btn-primary align-self-end" @click="submitClicked">
                                    {{ $t('acceptChanges') }}</CButton>
                                <!-- Loading -->
                                <FormLoading v-if="loading"></FormLoading>
                            </div>
                        </div>
                    </div>
                </CCardBody>
            </CCard>
        </CCol>
        <ConfirmationPopUp :confirmationMessage="confirmationMessage" @closeConfirmRequested="onClickConfirmationPopup"
            v-model="showConfirmationPopup"></ConfirmationPopUp>
    </div>
</template>
 
<script>
import { mapState } from 'vuex'
import router from '@/router/index';
import { API_HELPER } from "@/helpers/api.js";
import { deepClone } from "@/helpers/utils.js";
import { CONSTANTS } from '@/helpers/consts';
import { genericValidator, errorValidator } from "@/helpers/utils.js";
import Hero from "@/classes/Hero";
import LanguageDropdown from '@/controls/LanguageDropdown.vue'
import ConfirmationPopUp from "@/controls/popups/ConfirmationPopUp.vue";
import GalleryPicker from '@/controls/GalleryPicker.vue'
import { VueEditor } from "vue2-editor";
import FormLoading from '@/controls/FormLoading.vue'

export default {
    components: { LanguageDropdown, ConfirmationPopUp, VueEditor, GalleryPicker, FormLoading },
    props: {
        baseHero:
        {
            type: Object,
            default: null,
        },
        baseName:
        {
            type: String,
            default: null,
        },
        loading:
        {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            attemptedSubmit: false,
            currentLanguage: CONSTANTS.supportedLanguages[0],
            hero: new Hero({}, {}, {}),
            submitting: false,
            showConfirmationPopup: false,
            confirmationMessage: "",
        }
    },
    mounted: function () {
        this.resetHero();
    },
    computed:
    {
        ...mapState('heros', ['putHeroOutput']),
        ...mapState('heros', ['postHeroOutput']),
        ...mapState({
            alertType: state => state.alert.type,
            alertOutput: state => state.alert.output
        }),
        errorOutput: function () {
            var result = this.alertOutput && Array.isArray(this.alertOutput) ? this.alertOutput : [];

            // Validate multi language fields
            for (const [key, value] of Object.entries(this.hero.titles)) { if (!value) { result['Titles'] = this.$i18n.t("validateBothTranslations"); break; }; }
            for (const [key, value] of Object.entries(this.hero.contents)) { if (!value) { result['Contents'] = this.$i18n.t("validateBothTranslations"); break; }; }
            for (const [key, value] of Object.entries(this.hero.buttonContents)) { if (!value) { result['ButtonContents'] = this.$i18n.t("validateBothTranslations"); break; }; }

            return result;
        },
        name: function () {
            return this.baseHero || this.baseName ? (this.baseHero ? this.baseHero.name : this.baseName) : null;
        }
    },
    methods: {
        genericValidator,
        errorValidator,
        resetHero() {
            if (!this.baseHero) {
                var titles = {}; var contents = {}; var buttonContents = {};
                CONSTANTS.supportedLanguages.forEach(language => { titles[language.key] = ""; contents[language.key] = ""; buttonContents[language.key] = ""; });
                this.hero = new Hero(titles, contents, buttonContents);
            }
            else {
                this.hero = deepClone(new Hero, this.baseHero);
                this.hero.image = this.hero.image ? { url: API_HELPER.pathJoin([process.env.VUE_APP_URL_ROOT, this.hero.image]) } : null;
            }
        },
        submitClicked() {
            this.attemptedSubmit = true;

            // Emit event
            if (this.hero.isValid()) {
                this.submitting = true;
                this.$emit('submit-requested', this.hero);
            }
        },
        onClickConfirmationPopup(value) {
            this.showConfirmationPopup = value;
            router.push({name: 'HerosList'});
        },
        onProcessTask: function (val) {
            if (val != null) {
                if (val) {
                    this.showConfirmationPopup = true;
                }

                this.submitting = false;
            }
        }
    },
    watch:
    {
        putHeroOutput: function (val) {
            this.onProcessTask(val);
        },
        postHeroOutput: function (val) {
            this.onProcessTask(val);
        },
        baseHero: function () {
            this.resetHero();
        },
        alertOutput: function () {
            // Show pop up in case it is a string error
            // In case it is an array, it is shown on the field
            if (typeof this.alertOutput === 'string' || this.alertOutput instanceof String) {
                alert(this.alertOutput);
            }
        }
    }
}
</script> 
 
<style scoped>
@media only screen and (max-width: 767px) {
    .main-content {
        flex-direction: column;
    }
}

/deep/.quillWrapper.is-invalid .ql-snow.ql-toolbar,
/deep/.quillWrapper.is-invalid .ql-snow.ql-container {
    border-color: #e55353;
}
</style> 